import { matchSearch } from "../../utils/chosung";
import { enrichRecord } from "../../utils/recordUtils";

export const formatTeacherListDate = (dateString) => {
  if (!dateString || dateString === "-") return "-";
  const date = new Date(dateString);
  const yy = String(date.getFullYear()).slice(2);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

const getGradeIndex = (text) => {
  if (!text) return 9999;

  const match = text.match(/(초|중|고)\D*(\d)/);
  if (match) {
    const school = match[1];
    const grade = parseInt(match[2], 10);

    let base = 0;
    if (school === "초") base = 10;
    else if (school === "중") base = 20;
    else if (school === "고") base = 30;

    return base + grade;
  }

  if (text.includes("영아")) return 1;
  if (text.includes("유아")) return 2;
  if (text.includes("유치")) return 3;
  if (text.includes("청년")) return 40;
  if (text.includes("장년")) return 50;

  return 9999;
};

const KOREAN_NUMERIC_COLLATOR = new Intl.Collator("ko", {
  numeric: true,
  sensitivity: "base",
});

export const buildFilteredTeachers = ({
  attendanceLogs,
  departmentFilter,
  searchTerm,
  selectedDepartment,
  sortKey,
  sortOrder,
  teachers,
  visitLogs,
}) => {
  const teachersWithStats = teachers.map((teacher) => enrichRecord(teacher, attendanceLogs, visitLogs));

  const isGlobalAll = selectedDepartment === "All" || selectedDepartment === "전체";

  const result = teachersWithStats.filter((teacher) => {
    const matchesSearch =
      matchSearch(teacher.name || "", searchTerm) ||
      matchSearch(teacher.charge || "", searchTerm) ||
      matchSearch(teacher.responsibility || "", searchTerm) ||
      matchSearch(teacher.role || "", searchTerm);

    const matchesDept = isGlobalAll
      ? departmentFilter === "전체" || (teacher.charge && teacher.charge === departmentFilter)
      : (teacher.charge && teacher.charge.includes(selectedDepartment)) ||
      (teacher.deptName && teacher.deptName === selectedDepartment);

    return matchesSearch && matchesDept;
  });

  result.sort((a, b) => {
    let comparison = 0;

    if (sortKey === "responsibility") {
      const valA = a.responsibility || a.charge || "";
      const valB = b.responsibility || b.charge || "";

      const indexA = getGradeIndex(valA);
      const indexB = getGradeIndex(valB);

      if (indexA !== indexB) {
        comparison = indexA - indexB;
      } else {
        comparison = valA.localeCompare(valB);
      }
    } else if (sortKey === "lastAttendance" || sortKey === "lastVisit") {
      const valA = a[sortKey] ? new Date(a[sortKey]).getTime() : 0;
      const valB = b[sortKey] ? new Date(b[sortKey]).getTime() : 0;
      comparison = valA - valB;
    } else if (sortKey === "birth") {
      const valA = a.birth || "9999-99-99";
      const valB = b.birth || "9999-99-99";
      comparison = valA.localeCompare(valB);
    } else if (sortKey === "phone") {
      const valA = String(a.phone || "");
      const valB = String(b.phone || "");
      comparison = KOREAN_NUMERIC_COLLATOR.compare(valA, valB);
    } else {
      const valA = String(a[sortKey] || "");
      const valB = String(b[sortKey] || "");
      comparison = KOREAN_NUMERIC_COLLATOR.compare(valA, valB);
    }

    return sortOrder === "asc" ? comparison : -comparison;
  });

  return result;
};

export const buildSortedMinutes = (minutes) => {
  return [...minutes].sort((a, b) => new Date(b.date) - new Date(a.date));
};
